import { Link } from "react-router-dom";
import React from 'react'
import { useEffect, useRef, useState } from 'react'
import NavLink from '../NavLink'
import barrenPayLightLogo from "../../../assets/images/barrenPay-LightLogo.png"

const Navbar = () => {

    const [state, setState] = useState(false)

    const navigation = [
        { name: "Features", href: "/" },
        { name: "Pricing", href: "/" },
        { name: "Deals and Discounts", href: "/dealsanddiscounts" },
    ]

    const [showMenuIcon, setshowMenuIcon] = React.useState(false);
    return (
        <div>
            <header className='relative'>
                <nav className={`pb-5 md:text-sm md:static md:block ${state ? "bg-gray-900 absolute z-20 top-0 inset-x-0 rounded-b-2xl shadow-xl md:bg-gray-900" : "hidden"}`}>
                    <div className="custom-screen items-center md:flex">
                        <div className="flex items-center justify-between md:block">
                            <Link to="/">
                                <img className='landingLightLogo inline-flex' src={barrenPayLightLogo} alt="" srcset="" />
                            </Link>
                        </div>
                        <div className={`flex-1 items-center mt-8 text-gray-300 md:font-medium md:mt-0 md:flex ${state ? 'block' : 'hidden'} `}>
                            <ul className="flex-1 justify-center items-center space-y-6 md:flex md:space-x-6 md:space-y-0">
                                {
                                    navigation.map((item, idx) => {
                                        return (
                                            <li key={idx} className="hover:text-gray-50">
                                                <Link to={item.href} onClick={(() => { setState(false) })} className="block">
                                                    {item.name}
                                                </Link>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            <div className="gap-x-6 items-center justify-end mt-6 space-y-6 md:flex md:space-y-0 md:mt-0">
                                <Link to="/auth/signin" className="block hover:text-gray-50">
                                    Sign in
                                </Link>

                                <NavLink to="/auth/signup" className="flex items-center justify-center gap-x-1 text-sm text-white font-medium custom-btn-bg border border-gray-500 active:bg-gray-900 md:inline-flex">
                                    Sign Up Now
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                        <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                                    </svg>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>


            <header class="sticky top-0 z-50 block md:hidden">
                <div class="py-3">
                    <div class="">
                        <div class="flex items-center justify-between px-3">
                            <div class="flex-shrink-0 ml-2 mr-4 lg:ml-0">
                                <Link to="/">
                                    <a title="" class="flex items-center">
                                        <img class="block w-auto h-8" src={barrenPayLightLogo} alt="" onClick={(() => { setshowMenuIcon(false) })} />
                                    </a>
                                </Link>
                            </div>

                            <div class="flex-1 max-w-xs ml-auto lg:hidden">
                                <label for="" class="sr-only"> Search </label>
                            </div>

                            <div class="flex items-center ml-4 lg:ml-0">
                                <button type="button" class="inline-flex items-center justify-center p-2 text-white">

                                    {!showMenuIcon &&
                                        <span aria-hidden="true" onClick={() => { setshowMenuIcon(true) }}>
                                            <svg className="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 6h16M4 12h16M4 18h16" />
                                            </svg>
                                        </span>
                                    }

                                    {showMenuIcon &&
                                        <span aria-hidden="true" onClick={() => { setshowMenuIcon(false) }}>
                                            <svg className="w-7 h-7" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </span>
                                    }
                                </button>
                            </div>
                        </div>

                        {showMenuIcon &&
                            <nav x-show="expanded" x-collapse>
                                <div className="px-1 my-5 text-center bg-gray-900">
                                    <div className="grid gap-y-7 pb-8">

                                        {
                                            navigation.map((item, idx) => {
                                                return (
                                                    <Link to={item.href} className="hover:text-gray-50" onClick={(() => { setshowMenuIcon(false) })}>
                                                        <a title="" className="text-base font-medium text-white transition-all duration-200 font-pj hover:text-opacity-50  focus:ring-gray-900 focus:ring-offset-2">
                                                            {item.name}
                                                        </a>
                                                    </Link>
                                                )
                                            })
                                        }

                                        <div className="gap-x-6 items-center justify-end space-y-6 md:flex md:space-y-0 md:mt-0">
                                            <Link to="/auth/signin" className="block text-white" onClick={(() => { setshowMenuIcon(false) })}>
                                                Sign in
                                            </Link>

                                            <NavLink onClick={(() => { setshowMenuIcon(false) })} to="/auth/signup" className="flex items-center justify-center gap-x-1 text-sm text-white font-medium custom-btn-bg border border-gray-500 active:bg-gray-900 md:inline-flex">
                                                Sign Up Now
                                            </NavLink>
                                        </div>

                                    </div>
                                </div>
                            </nav>
                        }
                    </div>
                </div>
            </header>

        </div>
    )
}

export default Navbar